import { UpdateCommercialLicenseMappingComponent } from './update-commercial-license-mapping/update-commercial-license-mapping.component';
import { CreateCommercialLicenseMappingComponent } from './create-commercial-license-mapping/create-commercial-license-mapping.component';
import { CommercialLicenseMappingsComponent } from './commercial-license-mappings.component';
import { MainLayoutComponent } from '../../components/main-layout/main-layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';

export const commercialLicenseMappingsRoutes: Routes = [
    {
        path: 'admin/commercial-license-mappings',
        component: MainLayoutComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'ADMIN_PANEL',
                redirectTo: '/'
            }
        },
        children: [
            { path: '', component: CommercialLicenseMappingsComponent },
            { path: 'create', component: CreateCommercialLicenseMappingComponent },
            { path: ':id/update', component: UpdateCommercialLicenseMappingComponent }
        ]
    }
];
